import React from "react";
import { Checkbox } from "antd";

export const DEFAULT_SUFFIX_OPTIONS = [
  { label: "HO", value: "HO" },
  { label: "PRN", value: "PRN" },
  { label: "PRD", value: "PRD" },
  { label: "OTH", value: "OTH" },
];

export const DEFAULT_SELECTED_SUFFIXES = DEFAULT_SUFFIX_OPTIONS.map(
  (option) => option.value,
);

export const selectAllDropdownRender = (options, selected, setSelected) => (menu) => (
  <>
    <div
      style={{ padding: "4px 12px", borderBottom: "1px solid #f0f0f0" }}
      onMouseDown={(e) => e.preventDefault()}
    >
      <Checkbox
        checked={options.length > 0 && selected.length === options.length}
        indeterminate={
          selected.length > 0 && selected.length < options.length
        }
        onChange={(e) => {
          if (e.target.checked) {
            setSelected(options.map((o) => o.value));
          } else {
            setSelected([]);
          }
        }}
      >
        Select All
      </Checkbox>
    </div>
    {menu}
  </>
);
